const TextArea = ({label, placeholder, value, onError, rows, onBlur, onChange, customStyles, name}) => {
    return ( 
        <div>
            <div className="grid gap-[2px] text-sm">
                <span className="text-sm">{label}</span>
                <textarea placeholder={placeholder} onBlur={onBlur} onChange={onChange} value={value} name={name} id="" rows={rows} className={`w-full px-4 py-5 md:py-4 border text-sm focus:outline focus:outline-brandGreen/50 rounded ${customStyles}`}></textarea>
            </div>
          <span className="text-red-500 text-xs">{onError}</span>
        </div>
     );
}
 
export default TextArea;